import $http from '../../../axios';

export async function getSales({commit}, data) {
  commit('setLoading', true)
  await $http.get(`/api/facturas-tercero/${data.contact_id}`, {params:{dates:data.dates}})
  .then(async (response) => {
    await commit('setSales', response.data.data.sales);
    await commit('setContact', response.data.data.contact);
  })
  commit('setLoading', false)
}



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/sales-products/actions.js